<template>
    <div>
        <!-- 桌面端表格布局 -->
        <div class="hidden md:block overflow-x-auto track-list w-full">
            <table class="table table-pin-rows w-full min-w-[800px]">
                <thead>
                    <tr>
                        <th class="bg-base-200 font-semibold text-base-content/70 w-12">#</th>
                        <th class="bg-base-200 font-semibold text-base-content/70 min-w-0 max-w-[200px]">标题</th>
                        <th class="bg-base-200 font-semibold text-base-content/70 min-w-0 max-w-[150px]">艺术家</th>
                        <th class="bg-base-200 font-semibold text-base-content/70 min-w-0 max-w-[150px]" v-if="!noAlbum">专辑</th>
                        <th class="bg-base-200 font-semibold text-base-content/70 text-center w-20">时长</th>
                        <th class="bg-base-200 font-semibold text-base-content/70 text-center w-20">大小</th>
                        <th class="bg-base-200 font-semibold text-base-content/70 text-center w-20">比特率</th>
                        <th class="bg-base-200 font-semibold text-base-content/70 text-center w-16">播放</th>
                        <th class="bg-base-200 font-semibold text-base-content/70 text-center w-20">操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in tracks" :key="`${item.id}_${index}`" 
                        :draggable="draggable" 
                        @dragstart="dragStart($event, index)" 
                        @dragover.prevent 
                        @dragenter.prevent 
                        @drop="drop($event, index)" 
                        @dragend="dragEnd($event)"
                        :class="['hover:!bg-base-300 cursor-pointer transition-colors duration-200 border-b border-base-200/50', item.id === trackId && isPlaying ? 'bg-primary/10 text-primary' : '']">
                        <td @click="play(index)" class="py-4">
                            <div class="flex items-center justify-center">
                                <div v-if="item.id === trackId && isPlaying" class="flex items-center justify-center">
                                    <span class="loading loading-bars loading-sm text-primary"></span>
                                </div>
                                <div v-else class="text-center min-w-[2rem]">
                                    <div v-if="indexField === 'index'" class="text-base-content/70">
                                        {{ index + 1 }}
                                    </div>
                                    <div v-else class="text-base-content/70">
                                        {{ item.track }}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td @click="play(index)" class="py-4">
                            <div class="flex items-center gap-3">
                                <div class="flex-1 min-w-0">
                                    <div class="font-medium text-base-content truncate">{{ item.title }}</div>
                                    <div class="flex items-center gap-1 mt-1">
                                        <div class="badge badge-outline badge-xs" v-if="item.fromFolder === 'webdav'">
                                            <svg t="1705398013860" class="icon fill-current w-3 h-3" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M533.333333 256a212.416 212.416 0 0 1 212.864 205.333333l0.277334 7.488a52.970667 52.970667 0 0 0 35.413333 48.064l3.136 1.088a131.584 131.584 0 0 1 89.024 109.418667A128.128 128.128 0 0 1 746.666667 768H303.552a152.554667 152.554667 0 0 1-153.301333-132.629333 148.821333 148.821333 0 0 1 123.306666-163.690667l7.296-1.237333a53.034667 53.034667 0 0 0 42.88-40.682667l1.6-7.210667A214.570667 214.570667 0 0 1 533.333333 256m0-64a277.333333 277.333333 0 0 0-270.442666 216.554667A213.226667 213.226667 0 0 0 298.666667 832h448a192 192 0 0 0 63.488-373.034667A277.12 277.12 0 0 0 533.333333 192z"></path>
                                                <path d="M405.333333 618.666667m32 0l192 0q32 0 32 32l0 0q0 32-32 32l-192 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#FF9C00"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td @click="play(index)" class="py-4">
                            <div class="text-base-content/70 truncate">{{ item.artist }}</div>
                        </td>
                        <td @click="play(index)" class="py-4" v-if="!noAlbum">
                            <div class="text-base-content/70 truncate">{{ item.album }}</div>
                        </td>
                        <td @click="play(index)" class="py-4 text-center">
                            <div class="text-base-content/70">{{ formatDuration(item.duration) }}</div>
                        </td>
                        <td @click="play(index)" class="py-4 text-center">
                            <div class="text-base-content/70">{{ formatSize(item.size) }}</div>
                        </td>
                        <td @click="play(index)" class="py-4 text-center">
                            <div class="text-base-content/70">{{ item.bitrate }}kps</div>
                        </td>
                        <td @click="play(index)" class="py-4 text-center">
                            <div class="text-base-content/70">{{ item.playsCount }}</div>
                        </td>
                        <td class="py-4 text-center">
                            <track-action :item="item" :index="index"></track-action>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 移动端卡片布局 -->
        <div class="md:hidden space-y-2 min-h-[400px]">
            <div v-for="(item, index) in tracks" :key="`${item.id}_${index}`" 
                 :draggable="draggable"
                 @dragstart="dragStart($event, index)"
                 @dragover.prevent
                 @dragenter.prevent
                 @drop="drop($event, index)"
                 @dragend="dragEnd($event)"
                 :class="['card bg-base-100 shadow-sm hover:shadow-md transition-all duration-200 border border-base-200/30 rounded-lg', item.id === trackId && isPlaying ? 'border-primary shadow-primary/20' : '']">
                <div class="card-body p-3">
                    <div class="flex items-center gap-3" @click="play(index)">
                        <!-- 播放状态/序号 -->
                        <div class="flex-shrink-0 w-6 flex items-center justify-center">
                            <div v-if="item.id === trackId && isPlaying" class="flex items-center justify-center">
                                <span class="loading loading-bars loading-xs text-primary"></span>
                            </div>
                            <div v-else class="text-center text-base-content/70 font-medium text-sm">
                                <div v-if="indexField === 'index'">
                                    {{ index + 1 }}
                                </div>
                                <div v-else>
                                    {{ item.track }}
                                </div>
                            </div>
                        </div>
                        
                        <!-- 歌曲信息 -->
                        <div class="flex-1 min-w-0">
                            <div class="flex items-center gap-2">
                                <h3 class="font-semibold text-sm text-base-content truncate leading-tight">{{ item.title }}</h3>
                                <div class="badge badge-outline badge-xs px-1 py-0.5" v-if="item.fromFolder === 'webdav'">
                                    <svg t="1705398013860" class="icon fill-current w-2.5 h-2.5" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M533.333333 256a212.416 212.416 0 0 1 212.864 205.333333l0.277334 7.488a52.970667 52.970667 0 0 0 35.413333 48.064l3.136 1.088a131.584 131.584 0 0 1 89.024 109.418667A128.128 128.128 0 0 1 746.666667 768H303.552a152.554667 152.554667 0 0 1-153.301333-132.629333 148.821333 148.821333 0 0 1 123.306666-163.690667l7.296-1.237333a53.034667 53.034667 0 0 0 42.88-40.682667l1.6-7.210667A214.570667 214.570667 0 0 1 533.333333 256m0-64a277.333333 277.333333 0 0 0-270.442666 216.554667A213.226667 213.226667 0 0 0 298.666667 832h448a192 192 0 0 0 63.488-373.034667A277.12 277.12 0 0 0 533.333333 192z"></path>
                                        <path d="M405.333333 618.666667m32 0l192 0q32 0 32 32l0 0q0 32-32 32l-192 0q-32 0-32-32l0 0q0-32 32-32Z" fill="#FF9C00"></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="flex items-center gap-1 mt-0.5">
                                <p class="text-xs text-base-content/60 truncate flex-1">{{ item.artist }}</p>
                                <span v-if="!noAlbum && item.album" class="text-xs text-base-content/50">·</span>
                                <p class="text-xs text-base-content/50 truncate max-w-[120px]" v-if="!noAlbum && item.album">{{ item.album }}</p>
                            </div>
                            <div class="flex items-center gap-3 mt-1 text-xs text-base-content/50">
                                <span class="badge badge-ghost badge-xs px-1.5 py-0.5">{{ formatDuration(item.duration) }}</span>
                                <span>{{ formatSize(item.size) }}</span>
                                <span>{{ item.bitrate }}k</span>
                            </div>
                        </div>
                        
                        <!-- 操作按钮 -->
                        <div class="flex-shrink-0" @click.stop>
                            <track-action :item="item" :index="index"></track-action>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 空状态 -->
        <div v-if="!tracks || tracks.length === 0" class="flex flex-col items-center justify-center py-16 text-center">
            <h3 class="text-xl font-semibold text-base-content mb-2">暂无音乐</h3>
            <p class="text-base-content/60">还没有找到任何音乐，请稍后再试</p>
        </div>
    </div>
</template>

<script>
    import TrackAction from "@/views/library/track/TrackAction";
    import {mapGetters} from 'vuex'
    export default {
        components: {TrackAction},
        props: {
            tracks: {type: Array, required: true},
            noAlbum: {type: Boolean, default: false},
            noArtist: {type: Boolean, default: false},
            noDuration: {type: Boolean, default: false},
            indexField: {type: String, default: 'tracknumber'},
            draggable: {type: Boolean, default: false},
        },
        data() {
            return {
                playLists: [],
                id: this.$route.params.id,
                isShowCreatePlist: false,
                selectPlaylist: '',
                selectTrackID: '',
                plName: '',
                draggedIndex: null,
            }
        },
        computed: {
            ...mapGetters(['trackId']),
            isPlaying() {
                return this.$store.state.common.isPlaying
            }
        },
        created() {
        },
        methods: {
            formatDuration(value) {
                if (!isFinite(value)) {
                    return '∞'
                }
                const minutes = Math.floor(value / 60)
                const seconds = Math.floor(value % 60)
                return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds
            },
            formatSize(value) {
                return (value / 1024 / 1024).toFixed(1) + ' MB'
            },
            play(index) {
                if (this.tracks[index].id === this.trackId) {
                    return this.$store.dispatch('playPause')
                }
                return this.$store.dispatch('playTrackList', {
                    index,
                    tracks: this.tracks
                })
            },
            dragstart(item, event) {
                if (!item.isStream) {
                    event.dataTransfer.setData('application/x-track-id', item.id)
                }
            },
            addFavouriteTrack(item) {
                if (item.favourite) {
                    this.$api.subsonic.removeFavourite(item.id, 'track').then((res) => {
                        item.favourite = false
                    })
                } else {
                    this.$api.subsonic.addFavourite(item.id, 'track').then((res) => {
                        item.favourite = true
                    })
                }
            },
            removeTrackFromPlaylist(index) {
                this.tracks.splice(index, 1)
            },
            dragStart(event, index) {
                this.draggedIndex = index;
                event.dataTransfer.effectAllowed = 'move';
                event.target.style.opacity = '0.4';
            },
            dragEnd(event) {
                const rows = event.target.parentElement.getElementsByTagName('tr');
                for (let row of rows) {
                    row.style.opacity = '1';
                }
                // 移动端卡片的处理
                const cards = event.target.parentElement.getElementsByClassName('card');
                for (let card of cards) {
                    card.style.opacity = '1';
                }
            },
            drop(event, index) {
                event.preventDefault();
                const draggedItem = this.tracks[this.draggedIndex];
                const newItem = this.tracks[index];
                this.tracks.splice(this.draggedIndex, 1);
                this.tracks.splice(index, 0, draggedItem);
                
                if (this.$route.name === 'playlist') {
                    this.updatePlaylistOrder(draggedItem.index, newItem.index);
                }
                
                this.draggedIndex = null;
            },
            async updatePlaylistOrder(oldIndex, newIndex) {
                try {
                    const playlistId = this.$route.params.id;
                    
                    await this.$api.subsonic.updatePlaylistOrder(playlistId, oldIndex, newIndex);
                    this.$myMsg.notify({
                        title: '更新成功！',
                        type: 'success',
                        time: 2000,
                    });
                } catch (error) {
                    console.error('Failed to update playlist order:', error);
                    this.$myMsg.notify({
                        title: '更新失败！',
                        type: 'error',
                        time: 2000,
                    });
                }
            }
        }
    }
</script>

<style scoped>
.track-list {
    min-height: 400px;
    width: 100%;
}

.track-list table {
    table-layout: fixed;
}

/* 拖拽样式 */
.cursor-move {
    cursor: move;
}

/* 移动端触摸优化 */
@media (max-width: 768px) {
    .card {
        transition: transform 0.2s ease, box-shadow 0.3s ease;
    }
    
    .card:active {
        transform: scale(0.98);
    }
}

/* 桌面端hover效果 */
@media (min-width: 769px) {
    .track-list tr:hover {
        background-color: hsl(var(--b2));
    }
}

/* 滚动条样式 */
.track-list::-webkit-scrollbar {
    height: 6px;
}

.track-list::-webkit-scrollbar-track {
    background: hsl(var(--b2));
    border-radius: 3px;
}

.track-list::-webkit-scrollbar-thumb {
    background: hsl(var(--bc) / 0.2);
    border-radius: 3px;
}

.track-list::-webkit-scrollbar-thumb:hover {
    background: hsl(var(--bc) / 0.3);
}

/* 播放状态高亮 */
.text-primary {
    color: hsl(var(--p));
}

.bg-primary\/10 {
    background-color: hsl(var(--p) / 0.1);
}

.border-primary {
    border-color: hsl(var(--p));
}

.shadow-primary\/20 {
    box-shadow: 0 10px 15px -3px hsl(var(--p) / 0.2), 0 4px 6px -2px hsl(var(--p) / 0.1);
}
</style>
